import {usePanelsTemplate, usePanelsUpdate} from 'Event/template/Panels'
import ColorPicker from 'lib/ui/ColorPicker'
import Divider from 'lib/ui/ConfigPanel/Divider'
import Title from 'lib/ui/ConfigPanel/Title'
import Slider from 'lib/ui/Slider'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {Controller} from 'react-hook-form'

export default function RightPanelConfig() {
  const save = usePanelsUpdate()
  const {
    form: {control},
  } = useConfig()

  const template = usePanelsTemplate()
  const checkInTextColor = template.checkInRightPanel.textColor
    ? template.checkInRightPanel.textColor
    : template.textColor

  return (
    <Config title="Check In Right Panel" onSave={save}>
      <StylingPanel>
        <Title>Background</Title>
        <Controller
          name="checkInRightPanel.backgroundColor"
          defaultValue={template.checkInRightPanel.backgroundColor}
          control={control}
          render={({value, onChange}) => (
            <ColorPicker
              label="Color"
              color={value}
              onPick={onChange}
              aria-label="check in right panel background color"
            />
          )}
        />
        <Controller
          name="checkInRightPanel.backgroundOpacity"
          defaultValue={template.checkInRightPanel.backgroundOpacity}
          control={control}
          render={({value, onChange}) => (
            <Slider
              label="Opacity"
              min={0}
              max={100}
              step={1}
              onChange={onChange}
              value={value}
              unit="%"
            />
          )}
        />
        <Divider />
        <Title>Text</Title>
        <Controller
          name="checkInRightPanel.textColor"
          defaultValue={checkInTextColor}
          control={control}
          render={({value, onChange}) => (
            <ColorPicker
              label="Color"
              color={value}
              onPick={onChange}
              aria-label="check in right panel text color"
            />
          )}
        />
      </StylingPanel>
    </Config>
  )
}
